<template>
  <div id="index">
    <common-header></common-header>
    <div class="block-top">
      <p class="display-1 mincho" style="text-align:center;paddng:10px;">
        年表のテンプレートを選択してください。
     </p>
    </div>
    <div class="block-top block">
      <v-btn dark color="red" large :to="{ name: 'Edit2', params:{obj: {mode: 'new'}}}">ビジュアル</v-btn>
      <p>画像をたくさん使いたい方向けです。画像を各できごと毎に登録できます。</p>
      <v-btn dark color="red" large :to="{ name: 'Edit', params:{obj: {mode: 'new'}}}">シンプル</v-btn>
      <p>文字中心の方向けのシンプルなデザインです。</p>
    </div>
    <common-footer></common-footer>
  </div>
</template>

<script>
import CommonHeader from './common/CommomHeader'
import CommonFooter from './common/CommomFooter'
export default {
  name: 'Index',
  data () {
    return {
    }
  },
  computed: {
    isLogin () {
      return this.$store.state.view.isLogin
    }
  },
  components: {
    CommonHeader,
    CommonFooter
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("../assets/css/common.css");
.mainBtn{
  margin: 24px 0px;
  width: 100%;
  text-align:center;
}
.block{
  margin-top: 24px;
  width: 100%;
  text-align:center;
}
.block-top{
  margin-top: 10%;
  margin-bottom: 10%;
  width: 100%;
}
.block-subtitle {
  padding:0 20px;
  margin:0 auto;
  margin-bottom:10px;
}
.topMessage {
  max-width: 80%;
  width: 900px;
}
</style>



// WEBPACK FOOTER //
// src/components/SelectTemplate.vue